import { useLogger } from '#imports'
import useLayeredContent from './useLayeredContent'
import type { GamePage } from '../../utils/game-pages-config'
import { normalizeSeo } from '../../utils/seo-schema'

export function useContentGamePage() {
    const { queryAll, queryBySlug } = useLayeredContent()
    const logger = useLogger()

    async function getGamePages() {
        const all = await queryAll<GamePage>('game-pages')
        return all
            .filter(p => p.seoName !== 'overview' && p.seoName)
            .sort((a, b) => (a.seoName || '').localeCompare(b.seoName || ''))
    }

    async function getGamePageBySeoName(seoName: string) {
        const page = await queryBySlug<GamePage>('game-pages', seoName)
        if (!page) return null
        return {
            ...page,
            seo: normalizeSeo(page.seo, value => logger.error(`Malformed SEO on game page "${seoName}":`, value)),
        }
    }

    async function getGamePageOverview() {
        return await getGamePageBySeoName('overview')
    }

    return { getGamePages, getGamePageBySeoName, getGamePageOverview }
}
